import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import '../styles/pages/AboutUs.css';

const AboutUs = () => {
  return (
    <Container className="aboutus-container">
      <Helmet>
        <title>About Us - WeiFinders</title>
        <meta name="description" content="Discover WeiFinders, your travel companion for finding exciting new destinations, creating detailed itineraries, and sharing inspiring travel guides." />
        <meta property="og:title" content="About Us - WeiFinders" />
        <meta property="og:description" content="Discover WeiFinders, your travel companion for finding exciting new destinations, creating detailed itineraries, and sharing inspiring travel guides." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://weifinders.com/about" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@WeiFinders" />
        <meta name="twitter:title" content="About Us - WeiFinders" />
        <meta name="twitter:description" content="Discover WeiFinders, your travel companion for finding exciting new destinations, creating detailed itineraries, and sharing inspiring travel guides." />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About Us - WeiFinders",
            "url": "https://weifinders.com/about",
            "description": "WeiFinders is your ultimate platform for discovering destinations, crafting personalized itineraries, and sharing engaging travel content."
          }
        `}</script>
      </Helmet>
      <Card className="aboutus-card">
        <Card.Body>
          <article role="article">
            <header>
              <h2 className="aboutus-title">About WeiFinders</h2>
            </header>
            <p className="aboutus-description">
              WeiFinders was created with one simple vision—to help travelers discover remarkable destinations and simplify the journey from inspiration to experience. Whether you're looking for popular tourist spots, hidden gems, or personalized travel ideas, WeiFinders empowers you to plan effortlessly and explore with confidence.
            </p>

            <section>
              <h3 className="aboutus-subtitle">Our Mission</h3>
              <p className="aboutus-description">
                Our mission is to transform travel planning into an enjoyable, stress-free experience. By blending powerful AI tools, user-generated guides, and intuitive itinerary planning, WeiFinders enables you to effortlessly find your next favorite place.
              </p>
            </section>

            <section>
              <h3 className="aboutus-subtitle">How It Works</h3>
              <ul className="aboutus-list">
                <li><strong>Discover:</strong> Use our Popular, Recommended, and AI-powered suggestions to find destinations perfectly suited to your interests.</li>
                <li><strong>Create and Share:</strong> Write engaging travel blogs and comprehensive guides, enriched with your experiences, images, and helpful links.</li>
                <li><strong>Itinerary Planning:</strong> Build personalized itineraries, conveniently integrating Google Maps to visualize your trip.</li>
                <li><strong>Community Interaction:</strong> Engage with other travelers by sharing, liking, and reviewing guides and itineraries.</li>
              </ul>
            </section>

            <section>
              <h3 className="aboutus-subtitle">Our Commitment</h3>
              <p className="aboutus-description">
                At WeiFinders, we prioritize trust, quality, and innovation. Our platform uses advanced technologies like Google Maps and GeoNames to provide accurate and rich geographic data, ensuring an exceptional user experience. We’re committed to transparency, and our community drives the quality of content through active participation.
              </p>
            </section>

            <section>
              <h3 className="aboutus-subtitle">Join Our Journey</h3>
              <p className="aboutus-description">
                Ready to explore the world? Become a part of WeiFinders today. Whether you're a seasoned explorer or setting out on your first adventure, our platform is here to help you every step of the way.
              </p>
            </section>
          </article>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AboutUs;
